/**
 * Hash a string using SHA256
 * @param message - The string to hash
 * @returns Promise that resolves to the SHA256 hash as a hex string
 */
export const sha256 = async (message: string): Promise<string> => {
  const msgBuffer = new TextEncoder().encode(message)
  const hashBuffer = await crypto.subtle.digest('SHA-256', msgBuffer)
  const hashArray = Array.from(new Uint8Array(hashBuffer))
  const hashHex = hashArray.map((b) => b.toString(16).padStart(2, '0')).join('')
  return hashHex
}

/**
 * Normalize email address for consistent hashing
 * - Converts to lowercase
 * - Trims whitespace
 * - Removes dots from Gmail addresses
 * @param email - The email address to normalize
 * @returns Normalized email address
 */
export const normalizeEmail = (email: string): string => {
  const lowercaseEmail = email.toLowerCase().trim()
  const [localPart = '', domain] = lowercaseEmail.split('@')

  return `${localPart.replace(/\./g, '')}@${domain}`
}

/**
 * Normalize phone number to E.164 format for consistent hashing
 * - Removes all non-digit characters except the plus sign
 * - Expects vue-tel-input to handle validation and formatting
 * @param phone - The phone number to normalize
 * @returns Normalized phone number in E.164 format
 */
export const normalizePhone = (phone: string): string => {
  // Remove all non-digit characters except the plus sign
  return phone.replace(/[^\d+]/g, '')
}
